import React, { useEffect } from 'react';
import { List as IList } from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    Grid, Link, Typography, useMediaQuery, useTheme
} from '@mui/material';
import { intlShape, injectIntl } from 'react-intl';
import LaunchSharpIcon from '@mui/icons-material/LaunchSharp';
import {
    getCookieConsentEnabled
} from '../app/bootstrap';
import { getCardholderAgreementEnabled, getSupportedLocales } from '../brand/brandSelectors';
import CashstarLink from './CashstarLink';
import { getCustomCashstarLinks, getCardholderAgreementText } from './FooterSelector';
import CashstarLinksDefault from './CashstarLinksDefault';
import FooterLogos from './FooterLogos';
import FooterCardholderAgreement from './FooterCardholderAgreement';
import dynamicLinkMessages from '../brand/messages/DynamicLinkMessages';
import headerMessages from '../header/message/HeaderMessage';
import LanguageCurrencySelect from '../header/LanguageCurrencySelect';
import { getIntlCurrencyCode, getIntlLocale } from '../intl/intlSelectors';
import { getCurrencyPickerStatus } from '../localeCurrencyPicker/LocaleCurrencyPickerSelector';
import { localeDetails } from '../localeCurrencyPicker/CurrencyLocaleUtils';
import { trackHeaderFooterClick } from '../segment/segmentModule';
import { ccmBannerExists } from '../utils/cookieUtils';

export const NewFooter = ({
    customLinks,
    intl,
    cardholderText,
    isCardholderAgreementEnabled,
    locale,
    selectedCurrency,
    isCurrencyPickerStatus,
    callbackIsOpen,
    handleClickLocation,
    supportedLocales,
    trackExternalLinkClickAction
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const linkList = customLinks.map((link) => {
        const { text, url } = link.toJS();
        return (
            <Grid
                item
                className='grid-item-new'
                key={url}
            >
                <CashstarLink linkText={text} url={url} key={url} />
            </Grid>
        );
    });

    const handleClickOpen = () => {
        callbackIsOpen(true);
        handleClickLocation('Footer');
    };

    const { fullySupportedLocalesUniqueArr, localesForSelectedCountry } = localeDetails(supportedLocales, locale);

    
    
    
    const loadedTrustArcLocale = React.useRef(null);

    useEffect(() => {
        if (!getCookieConsentEnabled() || !intl) return undefined;

        
        
        
        const trustArcScriptExists = !!document.querySelector(
            'script[src*="trustarc.com/notice"], script[src*="truste.com/notice"]'
        );

        
        
        const isLocaleChange = loadedTrustArcLocale.current
            && loadedTrustArcLocale.current !== intl.locale;

        if (isLocaleChange) {
            
            
            
            
            
            
            
            
            const banner = document.getElementById('consent_blackbar');
            if (banner) banner.innerHTML = '';
            const teconsentMount = document.getElementById('teconsent');
            if (teconsentMount) teconsentMount.innerHTML = '';
            document
                .querySelectorAll('script[src*="trustarc.com"], script[src*="truste.com"]')
                .forEach(node => node.remove());
            [
                'truste',
                '_truste_eu',
                'PrivacyManagerAPI',
                'TRUSTE_CMAPI_DEBUG'
            ].forEach((key) => {
                try {
                    delete window[key];
                } catch (e) {
                    window[key] = undefined;
                }
            });
        } else if (trustArcScriptExists || ccmBannerExists()) {
            
            
            
            loadedTrustArcLocale.current = intl.locale;
            return undefined;
        }

        const cookieScript = document.createElement('script');
        cookieScript.src = `//consent.trustarc.com/notice?domain=nmi3gp&c=teconsent&js=nj&noticeType=bb&text=true&gtm=1&language=${intl.locale}&host=${encodeURIComponent(window.location.hostname)}`;
        cookieScript.async = true;
        cookieScript.crossOrigin = 'anonymous';
        document.body.appendChild(cookieScript);
        loadedTrustArcLocale.current = intl.locale;

        return () => {
            if (cookieScript.parentNode) {
                cookieScript.parentNode.removeChild(cookieScript);
            }
        };
    }, [intl]);

    return (
        <footer className='footer footer-new'>
            <div className='footer-container-new'>
                {isMobile && (
                    <>
                        <div className='manage-gift-cards'>
                            <Link
                                className='manage-gift-card-text'
                                href={intl.formatMessage(
                                    dynamicLinkMessages.manageGiftCard
                                )}
                                disableRipple
                                rel='noreferrer noopener'
                                target='_blank'
                                aria-label={`${intl.formatMessage(headerMessages.manageGiftCard)
                                } - opens in a new window`}
                                onClick={() => {
                                    trackExternalLinkClickAction('Footer Link Click',
                                        {
                                            title: intl.formatMessage(headerMessages.manageGiftCard),
                                            path: intl.formatMessage(dynamicLinkMessages.manageGiftCard)
                                        });
                                }}
                            >
                                {intl.formatMessage(
                                    headerMessages.manageGiftCard
                                )}
                                <LaunchSharpIcon
                                    className="footer-external-link"
                                    aria-hidden="true"
                                />
                            </Link>
                        </div>
                        <LanguageCurrencySelect
                            intl={intl}
                            locale={locale}
                            fullySupportedLocalesUniqueArr={
                                fullySupportedLocalesUniqueArr
                            }
                            localesForSelectedCountry={
                                localesForSelectedCountry
                            }
                            isCurrencyPickerStatus={
                                isCurrencyPickerStatus
                            }
                            handleClickOpen={handleClickOpen}
                            selectedCurrency={selectedCurrency}
                            footer
                        />
                    </>
                )}
                <Grid
                    container
                    className='footer-grid-container footer-grid-container-new'
                >
                    {customLinks.size ? linkList : <CashstarLinksDefault />}
                    {getCookieConsentEnabled() && (
                        <Grid item className='grid-item-new' key='teconsent'>
                            <Typography
                                onClick={() => trackExternalLinkClickAction(
                                    'Footer Link Click',
                                    {
                                        title: 'Cookie Preferences',
                                        destinationUrl: 'POP-UP'
                                    }
                                )}
                                className='footer-grid-item footer-grid-item-new footer-grid-item-without-icon'
                            >
                                <div id='teconsent' />
                            </Typography>
                        </Grid>
                    )}
                </Grid>
                <FooterLogos />
                {cardholderText && isCardholderAgreementEnabled && (
                    <FooterCardholderAgreement
                        cardholderText={cardholderText}
                    />
                )}
            </div>
        </footer>
    );
};

NewFooter.defaultProps = {
    cardholderText: null,
    isCardholderAgreementEnabled: false,
    supportedLocales: IList()
};

NewFooter.propTypes = {
    customLinks: PropTypes.instanceOf(IList).isRequired,
    intl: intlShape.isRequired,
    cardholderText: PropTypes.string,
    isCardholderAgreementEnabled: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    selectedCurrency: PropTypes.string.isRequired,
    callbackIsOpen: PropTypes.func.isRequired,
    handleClickLocation: PropTypes.func.isRequired,
    supportedLocales: PropTypes.instanceOf(IList),
    isCurrencyPickerStatus: PropTypes.bool.isRequired,
    trackExternalLinkClickAction: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    customLinks: getCustomCashstarLinks(state),
    cardholderText: getCardholderAgreementText(state),
    isCardholderAgreementEnabled: getCardholderAgreementEnabled(state),
    locale: getIntlLocale(state),
    supportedLocales: getSupportedLocales(state),
    selectedCurrency: getIntlCurrencyCode(state),
    isCurrencyPickerStatus: getCurrencyPickerStatus(state)
});

const mapDispatchToProps = {
    trackExternalLinkClickAction: trackHeaderFooterClick
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NewFooter));
